/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Container, TabContent, TabPane, Nav } from 'reactstrap';
import { useSelector } from 'react-redux';
import { SubHeader } from '~/components/SubHeader';
import { Text } from '~/components/Text';
import history from '~/services/history';
import ReactGA from 'react-ga4';
import Recebimentos from './Recebimentos';
import Vendas from './Vendas';
import ClientExtrato from '../Extrato';
import ClientExtratoDistribuidor from '../ExtratoDistribuidor';
// import ClientExtratoResumo from '../ExtratoResumo';

import Lancamentos from '../Lancamentos';
import Filial from '../Filial';
import AutorizarCred from './AutorizarCred';
import CredRevenda from './CredRevenda';
import Revendas from './Revendas';
import MeusPedidos from './MeusPedidos';
import MeusPedidosSemNotas from './MeusPedidosSemNotas';

import { TabsNavigation, NavLinkStyled, NavItemStyled } from './styles';
import Detalhamento from './Detalhamento';



export default function Transacoes(props) {
	const { user } = useSelector((state) => state.auth);
	const [isMobile, setIsMobile] = useState(false);
	const [activeTab, setActiveTab] = useState(user.dados.permissoes.view_meus_pedidos ? 'pedidos' : '');
	function handleClickVendasGA4() {
		ReactGA.event({
			category: "aba_vendas_click",
			action: "Acesso Aba Vendas",
			label: "Acessando aba vendas",
		});
	}

	function handleClickRecebimentosGA4() {
		ReactGA.event({
			category: "aba_recebimentos_click",
			action: "Acesso Aba Recebimentos",
			label: "Acessando aba recebimentos",
		});
	}

	function handleClickPedidosGA4() {
		ReactGA.event({
			category: "aba_pedidos_click",
			action: "Acesso Aba Pedidos",
			label: "Acessando aba Pedidos",
		});
	}

	function handleClickLancamentosGA4() {
		ReactGA.event({
			category: "aba_lancamentos_click",
			action: "Acesso Aba Lançamentos",
			label: "Acessando aba lançamentos",
		});
	}

	function handleClickExtratoGA4() {
		ReactGA.event({
			category: "aba_extrato_click",
			action: "Acesso Aba Extrato",
			label: "Acessando aba extrato",
		});
	}

	function handleClickFilialGA4() {
		ReactGA.event({
			category: "aba_filial_click",
			action: "Acesso Aba Filial",
			label: "Acessando aba Filial",
		});
	}


	const [tabConfigs, settabConfigs] = useState([
		{ key: 'pedidos', label: 'Meus Pedidos', condition: user.dados.permissoes.view_meus_pedidos, permission: 'view_meus_pedidos', handler: handleClickPedidosGA4 },
		{ key: 'autorizar', label: 'Distribuidores', condition: user.dados.permissoes.view_autorizar_credito_revenda, permission: 'view_autorizar_credito_revenda', handler: handleClickPedidosGA4 },
		{ key: 'consultaRevendas', label: 'Revendas', condition: user.dados.permissoes.view_autorizar_credito_parceiro, permission: 'view_autorizar_credito_parceiro', handler: handleClickPedidosGA4 },
		{ key: 'credRevenda', label: user.dados.permissoes.view_credito_revenda_distribuidor ? (user.dados.permissoes.view_farmacias ? "Farmácias" : user.dados.cargo.toLowerCase() === 'industria' ? 'Distribuidores' : "Revendedores") : 'Distribuidores', condition: user.dados.permissoes.view_credito_revenda_distribuidor || user.dados.permissoes.view_credito_parceiro, permission: 'view_credito_revenda_distribuidor', handler: handleClickPedidosGA4 },
		{ key: 'lancamentos', label: 'Lançamentos',  condition: user.dados.permissoes.view_lancamentos, permission: 'view_lancamentos', handler: handleClickLancamentosGA4 },
		{ key: 'filiais', label: 'Filiais', condition: user.dados.permissoes.view_filiais, permission: 'view_filiais', handler: handleClickFilialGA4 },
		{ key: 'extrato', label: (user.dados.permissoes.view_labels_pgm_triplo && user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor') ? 'Extrato de Créditos Revendas' :  'Extrato de Créditos', condition: user.dados.permissoes.view_extrato_credito, permission: 'view_extrato_credito', handler: handleClickExtratoGA4 },
		{ key: 'extratoDistribuidor', label: 'Meu Extrato de Crédito', condition: (user.dados.permissoes.view_extrato_credito && user.dados.permissoes.view_labels_pgm_triplo && user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor'), permission: 'view_extrato_credito', handler: handleClickExtratoGA4 },
		{ key: 'vendas', label: 'Vendas', condition: user.dados.permissoes.view_vendas, permission: 'view_vendas', handler: handleClickVendasGA4 },
		{ key: 'recebimentos', label: 'Recebimentos', condition: user.dados.permissoes.view_recebimentos, permission: 'view_recebimentos', handler: handleClickRecebimentosGA4 },
		{ key: 'resumo', label: 'Resumo', condition: user.dados.permissoes.detalhamento_financeiro_revenda || user.dados.permissoes.detalhamento_financeiro_industria || user.dados.permissoes.detalhamento_financeiro_participante, permission: 'detalhamento_financeiro_revenda', handler: handleClickExtratoGA4 }
	]);

	const toggle = (tab) => {
	  if (activeTab !== tab) setActiveTab(tab);
	  history.push(`/client/transacoes/${tab}`);
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 768);
		};
		handleResize();
		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	useEffect(() => {
	  const { location } = props;
	  if (location.state) {
		setActiveTab(location.state.type_movement.toLowerCase());
	  } else {
		const defaultTab = tabConfigs.find((tab) => user.dados.permissoes[tab.permission]);
		if (defaultTab) {
		  setActiveTab(defaultTab.key);
		}
	  }
	}, [user]);


	useEffect(() => {
		const path = history.location.pathname;
		const tipo = path.split('/')[3];
		if(tipo){
			setActiveTab(tipo)
		}
	  }, [history.location.pathname]);

	const handleTabClick = (key, handler) => {
	  handler();
	  toggle(key);
	};

	const renderTabs = () => {
	  return tabConfigs.map((tabConfig) => {
		if (tabConfig.condition) {
		  return (
			<NavItemStyled key={tabConfig.key}>
			  <NavLinkStyled
				active={activeTab === tabConfig.key}
				onClick={() => handleTabClick(tabConfig.key, tabConfig.handler)}
			  >
				<Text style={{ whiteSpace: 'nowrap' }}>{tabConfig.label}</Text>
			  </NavLinkStyled>
			</NavItemStyled>
		  );
		}
		return null;
	  });
	};

	const renderTabContent = () => {
	  return tabConfigs.map((tabConfig) => {
		if (tabConfig.condition) {
		  const Component = getComponentByTabKey(tabConfig.key);
		  return (
			<TabPane key={tabConfig.key} tabId={tabConfig.key}>
			  <Component user={user} isMobile={isMobile} />
			</TabPane>
		  );
		}
		return null;
	  });
	};

	const getComponentByTabKey = (key) => {
	  switch (key) {
		case 'pedidos':
		  return user.dados.permissoes.view_nf ? MeusPedidos : MeusPedidosSemNotas;
		case 'autorizar':
		  return AutorizarCred;
		case 'consultaRevendas':
		  return Revendas;
		case 'credRevenda':
		  return CredRevenda;
		case 'lancamentos':
		  return Lancamentos;
		case 'filiais':
		  return Filial;
		case 'extrato':
		  return ClientExtrato;
		case 'extratoDistribuidor':
		  return ClientExtratoDistribuidor;
		case 'vendas':
		  return Vendas;
		case 'recebimentos':
		  return Recebimentos;
		case 'resumo':
		  return Detalhamento;
		default:
		  return null;
	  }
	};

	return (
	  <Container fluid>
		<SubHeader />
		<TabsNavigation className="mt-5">
			<div className="nav-tabs-wrapper mb-0">
				<Nav
					tabs
					className="justify-content-start"
					style={{ display: 'flex', flexWrap: 'nowrap', overflowX: 'auto', scrollbarWidth: 'none' }}
				>
				{renderTabs()}
				</Nav>
			</div>
		</TabsNavigation>

		<TabContent activeTab={activeTab}>
		  {renderTabContent()}
		</TabContent>
	  </Container>
	);
  }

